export default __webpack_public_path__ + "static/media/newTabLink.c9be8577.svg";